import React, { useState } from "react";
import { Alert, TextField } from "@mui/material";
import { useFormik } from "formik"; // Ensure you're using Formik if this is part of the implementation
import * as Yup from "yup"; // Optional: For validation schema
import "./MUICustom.css"; // Optional: For custom styles
import { PiMapPinAreaFill } from "react-icons/pi";
import { FaPhone } from "react-icons/fa6";
import contactUs from "../assets/images/contactus.jpg";
import SocialIcons from "./SocialIcons";
import styles from "./ContactUs.module.css";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

function ContactUs() {
  const [response,setResponse] = useState(null);
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      message: Yup.string().required("Message is required"),
    }),
    onSubmit: (values) => {
      console.log("Form submitted:", values);
      axios.post(`${API_BASE_URL}messages/`, values).then((res) => {
        console.log(res);
        if (res.status === 200) {
          setResponse("success");

          // Clear form
          formik.resetForm();
        } else {
          setResponse("error");
          throw new Error("Failed to send message");
        }
      })
    },
  });

  return (
    <div className={`${styles.mask} pb-20`}>
      <div
        name="Contact"
        id="Contact"
        className="container mx-auto flex flex-col justify-center items-center bg-primary py-10 w-full md:w-2/3  px-8 md:px-4 "
      >
        {/* Heading */}
        <h1 className="text-5xl text-center text-primary font-poppins font-black py-3">
          Contact Us
        </h1>
        <p className="text-center text-secondary my-8">
          If you have any questions, feel free to reach out to us!
        </p>

        <div className="flex flex-col-reverse md:flex-row w-full gap-20">
          {/* Form */}
          <form
            onSubmit={formik.handleSubmit}
            className="contact-us-form flex flex-col gap-8 w-full sm:w-1/2"
          >
            <div className="flex flex-col gap-3 items-center w-full">
              <div className="w-full">
                <label
                  htmlFor="name"
                  className="block text-primary font-medium mb-2"
                >
                  Name <span className="text-danger">*</span>
                </label>
                <TextField
                  id="name"
                  fullWidth
                  placeholder="Enter your name"
                  {...formik.getFieldProps("name")}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </div>

              <div className="w-full">
                <label
                  htmlFor="email"
                  className="block text-primary font-medium mb-2"
                >
                  Email <span className="text-danger">*</span>
                </label>
                <TextField
                  id="email"
                  fullWidth
                  placeholder="Enter your email"
                  {...formik.getFieldProps("email")}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </div>

              <div className="w-full">
                <label
                  htmlFor="message"
                  className="block text-primary font-medium mb-2"
                >
                  Message <span className="text-danger">*</span>
                </label>
                <TextField
                  id="message"
                  fullWidth
                  multiline
                  rows={6}
                  placeholder="Enter your message"
                  {...formik.getFieldProps("message")}
                  error={
                    formik.touched.message && Boolean(formik.errors.message)
                  }
                  helperText={formik.touched.message && formik.errors.message}
                />
              </div>
              {response && (
                <Alert className="w-full" severity={response}>{response==="success"?"Message sent successfully":"Failed to send message"}</Alert>
              )}
              <button
                type="submit"
                className="bg-yellow text-tertiary px-6 py-3 rounded-md font-bold hover:bg-yellow-300 w-full z-10"
              >
                Send Message
              </button>
            </div>
          </form>
          {/* Right Column */}
          <div className="flex flex-col items-start gap-3 w-full sm:w-1/2 relative">
            <h2 className="text-lg text-primary">Our Head Office At Ukuwela</h2>
            <p className="text-secondary">
              We are located in the heart of Matale, Srilanka. Feel free to drop
              by anytime.
            </p>
            <img src={contactUs} className="w-3/4 aspect-square object-cover" alt="office-image" />
            <div className="flex items-center gap-2">
              <PiMapPinAreaFill size={20} />{" "}
              <span className="text-secondary">
                154/2/c , Matale road, Ukuwela
              </span>
            </div>
            <div className="flex items-center gap-2 mb-12">
              <FaPhone />
              <span className="text-secondary">+94 750360097</span>
            </div>
            <SocialIcons className="bottom-0 absolute" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
